import { useEffect, useMemo, useState } from "react";
import Modal from "../../components/Modal/Modal";
import { useApp } from "../../contexts";
import styled from "styled-components";
import environment from "../../environment";

const ContentWaper = styled.div`
  max-height: 80vh;
`;
export const ModalPolicy = ({ handleSubmit, disabled, ...props }) => {
  const { T, language } = useApp();
  const [disabledAccept, setDisabledAccept] = useState(true);

  const onClose = () => {
    props.onClose();
  };

  useEffect(() => {
    const handleMessage = (event) => {
      console.log("event", event);
      if (event.data?.type === "SCROLLED_TO_BOTTOM") {
        setDisabledAccept(false);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  
  const termsUrl = useMemo(() => {
    return `https://aiavatar.fun/affiliate-tnc/tnc/${language}/`;
  }, [language]);

  return (
    <Modal>
      <Modal.ModalBg2 required />
      <Modal.Container2
        width="850px"
        onClose={onClose}
        hiddenCloseIcon
        className={"!py-[30px] !pl-[22px] !pr-[22px]"}
      >
        <ContentWaper>
          <div className="text-center font-medium text-[18px] lg:text-[25px] tracking-[-0.96px] pb-[15px]">
            {T("Affiliate Program Terms and Conditions")}
          </div>
          <div className="modal-body content-agreement ">
            <iframe
              className="w-full border-0 h-[calc(80vh-140px)] overflow-auto"
              title={T("Affiliate Program Terms and Conditions")}
              src={termsUrl}
            ></iframe>
          </div>
          <div className="flex flex-row justify-center items-center pt-6 gap-[15px] border-0">
            <button
              className="sm:w-[192px] w-[100%] h-[52px] px-5 py-4 bg-black text-white text-center rounded-[15px] disabled:opacity-50 disabled:cursor-not-allowed"
              type="button"
              disabled={disabled || disabledAccept}
              onClick={() => handleSubmit()}
            >
              {T("Accept")}
            </button>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
